var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5116 8.65112C14.5116 7.26398 13.3871 6.13949 12 6.13949C10.6129 6.13949 9.48836 7.26398 9.48836 8.65112C9.48836 10.0382 10.6129 11.1627 12 11.1627C13.3871 11.1627 14.5116 10.0382 14.5116 8.65112ZM16.186 8.65112C16.186 10.963 14.3119 12.8372 12 12.8372C9.6881 12.8372 7.81394 10.963 7.81394 8.65112C7.81394 6.33923 9.6881 4.46507 12 4.46507C14.3119 4.46507 16.186 6.33923 16.186 8.65112Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3256 12C22.3256 6.29733 17.7026 1.67442 12 1.67442C6.29733 1.67442 1.67442 6.29733 1.67442 12C1.67442 17.7026 6.29733 22.3256 12 22.3256C17.7026 22.3256 22.3256 17.7026 22.3256 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37257 24 0 18.6274 0 12C5.66442e-06 5.37258 5.37258 5.66148e-06 12 0C18.6274 0 24 5.37257 24 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.5116C14.8417 14.5116 16.7412 15.116 17.9291 16.3479C19.1069 17.5694 19.4082 19.2321 19.4991 20.8842C19.5245 21.3459 19.1708 21.7407 18.7092 21.7661C18.2475 21.7915 17.8526 21.4379 17.8272 20.9762C17.7405 19.4006 17.4589 18.2726 16.7238 17.5102C15.9988 16.7584 14.6555 16.186 11.9999 16.186C9.34434 16.186 8.00104 16.7584 7.27606 17.5102C6.54097 18.2726 6.2593 19.4006 6.17258 20.9762C6.14716 21.4379 5.75231 21.7915 5.29063 21.7661C4.82896 21.7407 4.47531 21.3459 4.50071 20.8842C4.59165 19.2321 4.89294 17.5694 6.07071 16.348C7.2586 15.1161 9.1581 14.5116 11.9999 14.5116Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.29ddbf95bd939463e9b98fa5c8e9f889.svg";
export { ForwardRef as ReactComponent };